// Immediate mobile detection (runs synchronously, no React state)
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < 768;
};

// Cache the result at module load time for consistent behavior
export const IS_MOBILE = typeof window !== 'undefined' && window.innerWidth < 768;

/**
 * Systemeinstellung "Bewegung reduzieren".
 *
 * Der `@media (prefers-reduced-motion)`-Block in index.css erreicht nur
 * CSS-Animationen und -Transitions. Die auffälligsten Bewegungen der Seite
 * laufen aber über GSAP: der gepinnte Horizontal-Scroll der Cases, die
 * Einblend-Tweens, MagneticCursor und die Tilt-Karten.
 */
export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export const PREFERS_REDUCED_MOTION =
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
